import { LoadableAfterPaint } from '@confluence/loadable';

export const Comment = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Comment" */ './Comment')).Comment,
});

export type {
	CommentProps,
	CommentMode,
	CommentShape,
	CommentSaveHandler,
} from './commentSimpleTypes';

export { PageCommentEditor } from './PageCommentEditor';
